// @ts-strict-ignore
import {TableToggleableMetrics} from 'common/report/funnels/models/constants';

export const DEFAULT_STEPS_TABLE_COLUMNS = {
  [TableToggleableMetrics.ConvFirstStep]: false,
  [TableToggleableMetrics.ConvPrevStep]: true,
  [TableToggleableMetrics.Count]: true,
  [TableToggleableMetrics.StatSig]:
    typeof mixpanel === `undefined` ||
    mixpanel.flags?.get_variant_value_sync(`deprecate_funnel_stat_sig`, `control`) === `control`
      ? true
      : false,
  [TableToggleableMetrics.TimeFirstStep]: false,
  [TableToggleableMetrics.TimePrevStep]: true,
};
